// extracted by mini-css-extract-plugin
export default {"center":"Loader_center__WLvg3","container":"Loader_container__bS7FH","loading-bar-spinner":"Loader_loading-bar-spinner__J5NfM","icon":"Loader_icon__FJ2gY"};